import { render } from "./ModalEventResult.vue?vue&type=template&id=1ebc174a"
import script from "./ModalEventResult.vue?vue&type=script&lang=ts"
export * from "./ModalEventResult.vue?vue&type=script&lang=ts"
script.render = render

export default script